import * as Yup from 'yup';

export const priceTableSchema = Yup.object().shape({  
  id: Yup.number(),
  description: Yup.string().required('Descrição é obrigatória.'), 
  active: Yup.bool(),
});
